
module.exports = {
    webGL: require('./webgl/WebGLPrepare'),
    canvas: require('./canvas/CanvasPrepare')
};